import { getPaginatedSuppliers } from '../api/supplierAPI';

const SUPPLIER_INITIAL_BATCH_SIZE = 10;
const SUPPLIER_PAGE_SIZE = 5;

const extractSupplierItems = (result) => {
  if (Array.isArray(result)) {
    return result;
  }

  if (!result || typeof result !== 'object') {
    return [];
  }

  if (Array.isArray(result.data)) {
    return result.data;
  }

  if (Array.isArray(result.results)) {
    return result.results;
  }

  return [];
};

const extractSupplierTotal = (result) => {
  if (!result || typeof result !== 'object') return undefined;

  if (typeof result.totalCount === 'number') return result.totalCount;
  if (typeof result.total === 'number') return result.total;
  if (typeof result.count === 'number') return result.count;
  if (typeof result.meta?.total === 'number') return result.meta.total;

  return undefined;
};

const mapSupplierOptions = (items) =>
  (Array.isArray(items) ? items : []).map((supplier) => ({
    value: supplier.id,
    label: supplier.name,
    raw: supplier,
  }));

export const loadSupplierOptions = async (inputValue = '', { page = 1 } = {}) => {
  const raw = typeof inputValue === 'string' ? inputValue : inputValue?.search ?? '';
  const trimmed = raw.trim();
  const search = trimmed;
  const pageNumber = typeof page === 'number' && page > 0 ? page : 1;

  try {
    if (pageNumber === 1) {
      const [firstResp, secondResp] = await Promise.all([
        getPaginatedSuppliers({ page: 1, pageSize: SUPPLIER_PAGE_SIZE, search }),
        getPaginatedSuppliers({ page: 2, pageSize: SUPPLIER_PAGE_SIZE, search }),
      ]);

      const firstItems = extractSupplierItems(firstResp);
      const secondItems = extractSupplierItems(secondResp);
      const options = mapSupplierOptions([...firstItems, ...secondItems]);
      const totalCount = extractSupplierTotal(firstResp) ?? extractSupplierTotal(secondResp);
      const hasMore =
        typeof totalCount === 'number'
          ? options.length < totalCount
          : secondItems.length === SUPPLIER_PAGE_SIZE;

      return {
        options,
        hasMore,
        totalCount,
        pageSize: SUPPLIER_PAGE_SIZE,
      };
    }

    const apiPage = pageNumber + 1;
    const resp = await getPaginatedSuppliers({
      page: apiPage,
      pageSize: SUPPLIER_PAGE_SIZE,
      search,
    });
    const items = extractSupplierItems(resp);
    const options = mapSupplierOptions(items);
    const totalCount = extractSupplierTotal(resp);
    const loadedCount = SUPPLIER_INITIAL_BATCH_SIZE + (pageNumber - 1) * SUPPLIER_PAGE_SIZE;
    const hasMore =
      typeof totalCount === 'number'
        ? loadedCount < totalCount
        : items.length === SUPPLIER_PAGE_SIZE;

    return {
      options,
      hasMore,
      totalCount,
      pageSize: SUPPLIER_PAGE_SIZE,
    };
  } catch (err) {
    console.error('Error fetching suppliers:', err);
    return { options: [], hasMore: false };
  }
};
